import { BatchHttpLink } from '@apollo/client/link/batch-http'
import { APOLLO_URI_DEADPOOL_V2, APOLLO_URI_DEADPOOL_V3 } from '../config'

const baseConfig = {
  batchMax: 1,
  batchInterval: 200,
  credentials: 'omit',
}
const terminalLinkv2 = new BatchHttpLink({
  uri: APOLLO_URI_DEADPOOL_V2,
  ...baseConfig,
})

const terminalLinkv3 = new BatchHttpLink({
  uri: APOLLO_URI_DEADPOOL_V3,
  ...baseConfig,
})

export { terminalLinkv2, terminalLinkv3 }
